import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-music',
  templateUrl: './icon-music.component.html',
  styleUrls: ['./icon-music.component.scss']
})
export class IconMusicComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
